import {Component, OnDestroy} from '@angular/core';
import {IonicPage, NavController, NavParams} from 'ionic-angular';
import {DataProvider} from "../../providers/data/data";
import {HomePage} from "../home/home";
import {OrderPage} from "../order/order";
import {environment} from "../../environments/environment";
import {HttpClient} from "@angular/common/http";
import {PvsPage} from "../pvs/pvs";
import { BarcodeScanner } from '@ionic-native/barcode-scanner';
import {PvPage} from "../pv/pv";
import {MessagesPage} from "../messages/messages";
import {WareneingangPage} from "../wareneingang/wareneingang";

/**
 * Generated class for the OrdersPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */
@Component({
  selector: 'page-orders',
  templateUrl: 'orders.html',
})
export class OrdersPage implements OnDestroy {

  fast = 5000;
  slow = 30000;

  sub;

  constructor(public http: HttpClient, public navCtrl: NavController, public navParams: NavParams, public data: DataProvider, private barcodeScanner: BarcodeScanner) {
    this.sub = this.data.roleChange.subscribe(daten => {
      if (daten === 'Wareneingang') {
        this.navCtrl.setRoot(WareneingangPage);
      }
    });

  }

  ionViewDidLoad() {
    this.data.loadList();
    this.data.setIntervalList();
    this.data.role = '';
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  start(event, i) {
    this.navCtrl.push(OrderPage, {
      item: i
    });
  }

  open(event, i) {
    this.navCtrl.push(OrderPage, {
      item: i
    });
  }

  hintergrund(order) {
    if (order.erledigt === '0') {
      if (order.ersteller !== undefined) {
        if (order.ersteller > 0) {
          return 'new_tablet';
        }
      }
      return 'new';
    }
    if (order.erledigt === order.anzahl) {
      return 'done';
    }
    return 'active'
  }

  searchPvArticle(text) {
    const body = {
      token: localStorage.getItem('token'),
      module: 'packages',
      submodule: 'search',
      data: {text: text.value}
    };
    const sub = this.http.post(environment.api_url, body).subscribe(daten => {
        if (daten['data'].length === 0) {
          alert(daten['message']);
        } else {
          this.data.search_text = text.value;
          this.data.search_results = daten['data'];
          this.navCtrl.push(PvsPage);
        }
        sub.unsubscribe();
      }, error => {
      }
    );
  }

  scan() {
    this.barcodeScanner.scan({torchOn: true}).then((barcodeData) => {
      let scanned_pv = '0';
      if (barcodeData.format === 'QR_CODE') {
        const bstring = barcodeData.text.split('#');
        if (bstring[1] !== undefined) {
          scanned_pv = bstring[1];
        }
      }
      if (barcodeData.format === 'CODE_39') {
        scanned_pv = barcodeData.text;
      }
      this.openPv(scanned_pv);
    }, (err) => {

    });
  }

  openPv(number) {
    this.navCtrl.push(PvPage, {
      item: number
    });
  }

  openMessages() {
    this.data.unread_count = 0;
    this.navCtrl.push(MessagesPage);
  }

  logout() {
    localStorage.removeItem('token');
  }
}



// WEBPACK FOOTER //
// ./src/pages/orders/orders.ts